// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"705":"f68f0359","815":"f68f0359","885":"f68f0359"}[chunkId] + ".chunk.css";
};